/**
 * Brand — 본문에 "Heinrich" 단어만 Liberation Serif 폰트로 렌더.
 *
 * 사용:
 *   <Brand />                      → "Heinrich" 한 단어 출력
 *   {renderWithBrand("Heinrich 는 ...")}  → 문자열 안 모든 Heinrich 자동 wrap
 */
import { Fragment, type ReactNode } from 'react'

const BRAND_FONT = '"Liberation Serif", "Tinos", "Times New Roman", serif'
const BRAND_NAME = 'Heinrich'

interface Props {
  className?: string
}

export default function Brand({ className }: Props) {
  return (
    <span
      className={className}
      style={{ fontFamily: BRAND_FONT, textTransform: 'none', letterSpacing: 'normal' }}
    >
      {BRAND_NAME}
    </span>
  )
}

/**
 * 문자열 안의 모든 "Heinrich" 를 Brand 컴포넌트로 감싸 ReactNode 반환.
 * i18n 문자열 등 인라인 본문에 사용.
 */
export function renderWithBrand(text: string): ReactNode {
  if (!text || !text.includes(BRAND_NAME)) return text
  const parts = text.split(BRAND_NAME)
  return parts.map((part, i) => (
    <Fragment key={i}>
      {part}
      {i < parts.length - 1 && <Brand />}
    </Fragment>
  ))
}
